// --------------------------------
// Format a number of cents into USD currency format
// --------------------------------
export function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

// --------------------------------
// Generate HTML for a single cart item
// Includes image if it is present, title, quantity, and price
// --------------------------------
export function buildCartItemHTML(item) {
  return `
    <div class="cart-preview-item">
      ${
        item.image
          ? `<img src="${item.image}" alt="${item.title}" class="cart-item-image">`
          : ""
      }
      <div class="cart-item-details">
        <h4>${item.title}</h4>
        <p>Qty: ${item.quantity}</p>
        <p class="price">${formatMoney(item.line_price)}</p>
      </div>
    </div>
  `;
}

// --------------------------------
// Create full HTML for cart preview modal
// Limits visible items to 3 and adds scroll when over 3 item limit
// --------------------------------
export function buildCartHTML(items, totalPrice) {
  const maxVisibleItems = 3;
  const itemsHTML = items.map(buildCartItemHTML).join("");
  const showScroll = items.length > maxVisibleItems;

  return `
    <div class="cart-preview">
      <div class="cart-items-wrapper${showScroll ? ' scrollable' : ''}">
        ${itemsHTML}
      </div>
      <div class="cart-total">
        <p>Total: ${formatMoney(totalPrice)}</p>
      </div>
    </div>
  `;
}

// --------------------------------
// Fetch cart data from Shopify's /cart.js
// Returns a cart object or throws an error on failure
// --------------------------------
export async function fetchCartData() {
  const response = await fetch("/cart.js");

  if (!response.ok) throw new Error("Failed to fetch cart data");

  return await response.json();
}

// --------------------------------
// Show the cart modal and implement HTML content
// --------------------------------
export function showCartModal(html) {
  const cartMessage = document.getElementById("cart-message");
  const cartItem = document.getElementById("cart-item");

  if (!cartMessage || !cartItem) {
    console.error("Cart modal elements missing");
    return;
  }

  cartItem.innerHTML = html;
  cartMessage.style.display = "block";
  cartMessage.classList.add("active");
}

// --------------------------------
// Hide the cart modal
// --------------------------------
export function hideCartModal() {
  const cartMessage = document.getElementById("cart-message");

  if (cartMessage) {
    cartMessage.classList.remove("active");
    setTimeout(() => {
      cartMessage.style.display = "none";
    }, 300);
  }
}

// --------------------------------
// Fetch cart data and display preview modal
// Hides modal if cart is empty or shows error if fetch fails
// --------------------------------
export async function showCartPreview() {
  try {
    const cartData = await fetchCartData();

    // If no items in cart, close modal
    if (!cartData.items?.length) {
      hideCartModal();
      return;
    }

    const html = buildCartHTML(cartData.items, cartData.total_price);
    showCartModal(html);
  } catch (error) {
    console.error("Cart error:", error);
  }
}
